import React from "react";
import "./loader.css";
const ButtonLoader = () => {
  return <span class="btn-loader"></span>;
};

export default ButtonLoader;
